export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0060.95ea77f1.webp";